/**
 * @file index.tsx
 *
 * @fileoverview Renders a component.
 */
import React, { useContext } from 'react';
import dynamic from 'next/dynamic';
import RECRUITER_SIDE_MENU from '~/jobiqo/components/Layout/Recruiter/components/RecruiterSidebar/side_menu_recruiter.gql';
import { AppContextInterface } from '~/jobiqo/models/app';
import { AppContext } from '~/jobiqo/context/app';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { MenuItem } from '~/jobiqo/types/types';
import LayoutMenuItemWrapper from '~/jobiqo/components/Layout/components/MenuItemWrapper';
import { HideMobile } from '~/vcl/atoms/06-layout/02-visibility/02-hide-mobile';
import { SideBlock } from '~/vcl/organisms/07-navigation/02-side-block';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { HiddenVisually as VisuallyHidden } from '~/vcl/atoms/14-w-a11y/02-visually-hidden';
import { HideDesktop } from '~/vcl/atoms/06-layout/02-visibility/01-hide-desktop';
import { BottomMenu } from '~/vcl/organisms/07-navigation/03-bottom-menu';
import { Hr } from '~/vcl/atoms/06-layout/10-hr';

const OrganizationLink = dynamic(
  () => import('~/jobiqo/components/Organization/OrganizationLink'),
  {
    ssr: false,
  },
);
const OrganizationSwitcher = dynamic(
  () => import('~/jobiqo/components/Organization/Switcher'),
  {
    ssr: false,
  },
);

interface RecruiterSidebarProps {
  /**
   * if the sidebar is collapsed.
   */
  collapsed: boolean;
  /**
   * Toggles collapsing sidebar.
   */
  toggleSidenavCollapsed: () => void;
}
export const RecruiterSidebar = ({
  collapsed,
  toggleSidenavCollapsed,
}: RecruiterSidebarProps) => {
  const appContext: AppContextInterface = useContext(AppContext);

  let recruiterSideMenu: any = null;

  const { data } = useQuery(RECRUITER_SIDE_MENU, {
    variables: {
      menu: 'side-menu-recruiter',
      language: appContext.locale,
    },
  });

  if (data?.recruiterSideMenu) {
    recruiterSideMenu = data?.recruiterSideMenu;
  }

  return (
    <>
      <HideMobile>
        <SideBlock
          collapsed={collapsed}
          onCollapse={() => {
            toggleSidenavCollapsed();
          }}
        >
          <>
            <Spacing size="large" />
            <nav aria-labelledby="aside-navigation">
              <VisuallyHidden id="aside-navigation">
                <FormattedMessage
                  id="aside-navigation"
                  defaultMessage="Aside navigation"
                />
              </VisuallyHidden>
              {recruiterSideMenu &&
                recruiterSideMenu.items.map((menuItem: MenuItem) => (
                  <LayoutMenuItemWrapper
                    key={menuItem.title}
                    menuItem={menuItem}
                    position="side"
                  />
                ))}
              <OrganizationLink />
              <Hr />
              <OrganizationSwitcher hideText={collapsed} />
            </nav>
          </>
        </SideBlock>
      </HideMobile>
      <HideDesktop>
        <BottomMenu>
          {recruiterSideMenu &&
            recruiterSideMenu.items.map((menuItem: MenuItem) => (
              <LayoutMenuItemWrapper
                key={menuItem.title}
                menuItem={menuItem}
                position="bottom"
              />
            ))}
          <OrganizationLink />
        </BottomMenu>
      </HideDesktop>
    </>
  );
};
export default RecruiterSidebar;
